import { Container, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FeeCalculator } from '../components/Billing/FeeCalculator';
import { Plans } from '../components/Billing/Plans';
import { SubscriptionPlans } from '../components/Billing/SubscriptionPlans';
import { Footer } from '../components/Layout/Footer';

export function PricingPage() {
  const { t } = useTranslation();

  return (
    <>
      <Container size="xl" py={64} px="md">
        <Stack gap={96}>
          {/* Hero */}
          <Stack gap="md" align="center" maw={720} mx="auto" ta="center" pt={32}>
            <Title order={1} size="3rem" fw={700} lh={1.1} style={{ letterSpacing: '-0.02em' }}>
              {t('glob_navigation.pricing')}
            </Title>
            <Text size="lg" c="dimmed" lh={1.6}>
              {t('billing.pricing.heroBody')}
            </Text>
          </Stack>

          {/* Subscription Plans */}
          <Stack gap="xl">
            <Stack gap="xs" align="center" ta="center">
              <Title order={2} fw={600}>
                {t('billing.pricing.plansTitle')}
              </Title>
              <Text c="dimmed">{t('billing.pricing.plansBody')}</Text>
            </Stack>
            <SubscriptionPlans />
          </Stack>

          {/* Pay as you go */}
          <Stack gap="xl">
            <Stack gap="xs" align="center" ta="center">
              <Title order={2} fw={600}>
                {t('billing.pricing.paygTitle')}
              </Title>
              <Text c="dimmed">{t('billing.pricing.paygBody')}</Text>
            </Stack>
            <FeeCalculator />
          </Stack>

          {/* Comparison */}
          <Stack gap="xl">
            <Stack gap="xs" align="center" ta="center">
              <Title order={2} fw={600}>
                {t('billing.comparison')}
              </Title>
              <Text c="dimmed">{t('billing.pricing.comparisonBody')}</Text>
            </Stack>
            <Plans />
          </Stack>
        </Stack>
      </Container>

      <Footer />
    </>
  );
}
